import { update } from "./streams";
import { canvas } from "./canvas";
import { state } from "./App";
import { multiply, add, rotate, cross } from "./vectors";
import {
  ffF310gamepadMaker,
  gamepadMaker,
  emptyGamepadMaker
} from "./gamepads";

function setFunctions(string) {
  try {
    window.eval(string);
    state.setError("No errors :)");
  } catch (e) {
    state.setError(e.name + " " + e.message);
  }
}

function userWrapper(model) {
  for (let motor of model.motors) {
    window[motor.name] = motor.motor;
  }
  let gamepads = navigator.getGamepads();
  if (model.gamepad1_index !== null) {
    if (gamepads[model.gamepad1_index].mapping == "standard") {
      window.gamepad1 = gamepadMaker(gamepads[model.gamepad1_index]);
    } else if (
      gamepads[model.gamepad1_index].id.search("Logitech Gamepad F310") !== -1
    ) {
      window.gamepad1 = ffF310gamepadMaker(gamepads[model.gamepad1_index]);
    }
  } else {
    window.gamepad1 = emptyGamepadMaker();
  }
  if (model.gamepad2_index !== null) {
    if (gamepads[model.gamepad2_index].mapping == "standard") {
      window.gamepad2 = gamepadMaker(gamepads[model.gamepad2_index]);
    } else if (
      gamepads[model.gamepad2_index].id.search("Logitech Gamepad F310") !== -1
    ) {
      window.gamepad2 = ffF310gamepadMaker(gamepads[model.gamepad2_index]);
    }
  } else {
    window.gamepad2 = emptyGamepadMaker();
  }

  window.telemetry = {
    addData(string, data) {
      console.log(string, data);
    },
    update() {}
  };

  window.System = {
    currentTimeMillis() {
      return Math.trunc((model.initial_time + model.current_time) * 1000);
    }
  };

  window.duration = function() {
    return model.current_time;
  };

  window.gyro = {
    getHeading() {
      let heading = (model.gyro_heading * 180) / Math.PI;
      heading = heading % 360;
      if (heading < 0) {
        heading = 360 + heading;
      }
      let res = heading.toFixed(2);
      if (res === "-0.00") {
        res = "0.00";
      }
      return res;
    },
    getIntegratedZValue() {
      return (model.gyro_heading * 180) / Math.PI;
    },
    resetZAxisIntegrator() {
      model.gyro_heading = 0;
    }
  };

  if (typeof loop === "function") {
    try {
      loop();
      state.setError("No errors :)");
    } catch (e) {
      state.setError(e.name + " " + e.message);
    }
  } else {
    state.setError("loop is not a function");
  }

  for (let motor of model.motors) {
    motor.motor = window[motor.name];
  }
  return model;
}

function physicsUpdate(model) {
  if (model.previous_time > 0) {
    if (model.real_time) {
      model.dt = new Date().getTime() / 1000 - model.previous_time;
    }
  } else {
    model.previous_time = new Date().getTime() / 1000;
  }

  if (model.initial_time == 0) {
    model.initial_time = new Date().getTime() / 1000;
  }

  let torque = 0;

  model.a_local.x = 0;
  model.a_local.y = 0;

  for (let motor of model.motors) {
    motor.motor.simulate(model.dt);
    let f = { x: 0, y: motor.motor.getForce() };

    if (motor.hasOwnProperty("angle")) {
      f = rotate(f, motor.angle);
    }
    if (motor.hasOwnProperty("coefficient")) {
      f = multiply(f, motor.coefficient);
    }

    torque += cross(motor.position, f);

    let f_a = multiply(f, 1 / model.mass);

    model.a_local = add(model.a_local, f_a);
  }

  model.v_local = add(model.v_local, multiply(model.a_local, model.dt));

  let I = (model.mass / 12) * 2 * Math.pow(model.width, 2);
  let ang_acc = torque / I;
  model.omega += ang_acc * model.dt;
  model.heading += model.omega * model.dt;
  model.gyro_heading += model.omega * model.dt;

  model.v = rotate(model.v_local, model.heading);
  model.a = rotate(model.a_local, model.heading);

  model.pos = add(model.pos, multiply(model.v, model.dt));

  model.current_time += model.dt;

  if (
    model.pos.x + model.width / 2 >=
    model.canvas_size / model.pixels_per_meter
  ) {
    model.pos.x = model.canvas_size / model.pixels_per_meter - model.width / 2;
  } else if (model.pos.x - model.width / 2 <= 0) {
    model.pos.x = model.height / 2;
  }

  if (
    model.pos.y + model.height / 2 >=
    model.canvas_size / model.pixels_per_meter
  ) {
    model.pos.y = model.canvas_size / model.pixels_per_meter - model.height / 2;
  } else if (model.pos.y - model.height / 2 <= 0) {
    model.pos.y = model.height / 2;
  }

  model.previous_time = new Date().getTime() / 1000;

  return model;
}

function updateModel() {
  update(model => userWrapper(physicsUpdate(model)));
}

export { setFunctions, updateModel };



//////////////////
// WEBPACK FOOTER
// ./src/updateModel.js
// module id = 9
// module chunks = 0